module.exports = __webpack_public_path__ + "img/question_circle.2ac8d2f9.svg";